


















































import { Component, Vue, Prop, Mixins } from 'vue-property-decorator';
import { getFormatDate } from '@/utils/common';
import widgetCommon from './widgetCommon';
import { getCurrentYear } from '@/utils/common';
const currentYear = getCurrentYear();
@Component({
	components: {}
})
export default class extends Mixins(widgetCommon) {
	private show = false;
	private showField = '';
	private minDate = new Date(currentYear - 100, 0, 1);
	private maxDate = new Date(currentYear + 100, 11, 31);
	private showTime: any = '';
	private get rules() {
		return this.commonRule.concat({
			validator: this.validatorFn,
			message: '必填',
			trigger: 'onBlur'
		} as any) as any;
	}
	public initField() {
		if (!this.form[this.item.businessId]) {
			this.$set(this.form, this.item.businessId, {});
		}
		if (!this.form[this.item.businessId].endTime) {
			this.$set(this.form[this.item.businessId], 'endTime', this.item.defaultValue.endTime || '');
		}
		if (!this.form[this.item.businessId].startTime) {
			this.$set(
				this.form[this.item.businessId],
				'startTime',
				this.item.defaultValue.startTime || ''
			);
		}
	}
	public resultFn(value) {
		if (value instanceof Date) {
			return getFormatDate(value, this.item.dateType === 1 ? 'date' : 'datetime');
		}
	}
	public mounted() {
		if (this.type.includes('record')) {
			this.initField();
		}
	}
	private setDate(val) {
		let time = this.resultFn(val);
		const fieldMap = {
			startTime: 'endTime',
			endTime: 'startTime'
		};
		const anotherTimeField = fieldMap[this.showField];
		const timeRange = {
			[this.showField]: time,
			[anotherTimeField]: this.form[this.item.businessId][anotherTimeField]
		};
		const { startTime, endTime } = timeRange;
		if (startTime && endTime && startTime > endTime) {
			this.$toast.fail('开始时间不能大于结束时间。');
			return;
		}
		this.form[this.item.businessId][this.showField] = time;
		this.changePopup(false);
	}
	private changePopup(type, field: string = '') {
		if (this.disabled) {
			return;
		}
		this.show = type;
		if (type) {
			this.showField = field;
			let value = this.form[this.item.businessId][field];
			this.showTime = value ? new Date(value) : new Date();
		}
	}
	private validatorFn(value: string, rule: any) {
		const {startTime = '', endTime = ''} = this.form[this.item.businessId]
		// 开始时间和结束时间只有一个有值时，另外一个校验不通过
		if (Boolean(startTime) !== Boolean(endTime) && !value) {
			return false
		}
		return true
	}
}
